// DO NOT REMOVE THIS DUPLICATE INTERFACE
// This runs in a separate worker and hence cannot be imported
export interface SearchSymbolResults {
    security_id: number;
    symbol: string;
    market_id: string;
    scrip_name: string;
    series: string;
    symbol_id: number;
    expiry?: string;
    option_type?: string;
    strike_price?: number;
    instrument_type: string;
    lot_size: number;
    scrip_precision?: number;
    tick_size?: number;
    company_name?: string;
    search_instrument_type: string;
    contract_type?: OrderCategory;
}

export enum SEARCH_SYMBOL_INSTRUMENT_TYPE {
    COMMON_STOCK = 'common_stock',
    FUTURE = 'future',
    OPTION = 'option',
    INDEX = 'INDEX'
}

export enum OPTION_TYPE {
    call = 'CE',
    put = 'PE'
}

export enum FilterOptions {
    expiry = 'expiry',
    strike_price = 'strike_price',
    basic = 'basic',
    monthly = 'monthly',
    weekly = 'weekly',
    empty = '',
    symbol = 'symbol',
    index = 'index'
}

export enum OrderCategory {
    single = 'single',
    spread = 'spread',
    amo = 'amo',
    multileg = 'multi leg',
    auction = 'auction'
}

export enum IndexSymbol {
    NIFTY = 'NIFTY 50',
    BANKNIFTY = 'NIFTY BANK',
    FINNIFTY = 'NIFTY FIN SERVICE',
    MIDCPNIFTY = 'NIFTY MIDCAP 50',
    SENSEX = 'SENSEX',
    BANKEX = 'BANKEX',
    NIFTYNXT50 = 'NIFTY NEXT 50',
    SENSEX50 = 'SNSX50'
};

export enum UnderlyingMarketMap {
    NSECM = 'NSECM',
    NSEFO = 'NSECM',
    BSEFO = 'BSECM',
    BSECM = 'BSECM',
    NSECDS = 'NSECDS',
    BSECDS = 'BSECDS',
    MCX = 'MCX'
}

const SPECIAL_SYMBOLS = '/[- &*. ]/';


export const symbolDateFormat = {
    fullDate: 'DDMMMYY',
    monthly: 'MMM',
    yearly: 'YYYY',
    date: 'DD'
}


// Maps Char To Index
const charMap = new Map([
    ['0', 0], ['1', 1], ['2', 2], ['3', 3],
    ['4', 4], ['5', 5], ['6', 6], ['7', 7],
    ['8', 8], ['9', 9], ['A', 10], ['B', 11],
    ['C', 12], ['D', 13], ['E', 14], ['F', 15],
    ['G', 16], ['H', 17], ['I', 18], ['J', 19],
    ['K', 20], ['L', 21], ['M', 22], ['N', 23],
    ['O', 24], ['P', 25], ['Q', 26], ['R', 27],
    ['S', 28], ['T', 29], ['U', 30], ['V', 31],
    ['W', 32], ['X', 33], ['Y', 34], ['Z', 35],
    ['.', 36], ['-', 37] // "." is treated as character in case of strike price.
]);

/**
 * Base Node for Trie
 * @param data -> stores character
 * {Array} refList -> List of words containing word
 * {bool} isWord -> If the current node is a word
 * {sNode} nodes -> List of Nodes in the childern
 */
export class SNode {
    data: string = null;
    refList: (number | string)[] = [];
    isWord = false;
    nodes: SNode[] = [];

    constructor(data: string) {
        this.data = data;
    }
}

/**
 * Search Data Structure Implementation
 * Retrieves the list of symbol to be shown in symbol Search
 * SeachTree
 * @method insert Insert to new Element
 * @method getWords Returns The List of words of a given node
 */
export class SearchTree {
    root: SNode = null;
    wordList: (string | number)[] = [];

    constructor() {
        this.root = new SNode('');
    }

    insert(string: string, strObj?: SearchSymbolResults) {
        const strarr = string.split(' ');
        strarr.forEach(str => {
            const strLen = str.length;
            str = str.toUpperCase();
            let index = 0;
            let current = this.root;

            while (index !== strLen) {
                const char = str[index++];
                if (!current.nodes[charMap.get(char)]) {
                    current.nodes[charMap.get(char)] = new SNode(char);
                }
                current = current.nodes[charMap.get(char)];
            }
            current.isWord = true;
            if (strObj) {
                current.refList.push(strObj.market_id + '_' + strObj.security_id);
            }
            return this.root;

        });
    }

    search(str: string) {
        this.wordList = [];
        const strLen = str.length;
        str = str.toUpperCase();
        let index = 0;
        let current = this.root;

        while (index !== strLen) {
            if (!current) {
                return {
                    node: null,
                    retString: str.slice(0, index)
                };
            }
            current = current.nodes[charMap.get(str[index++])];
        }
        return {
            node: current,
            retString: str.slice(0, index)
        };
    }

    getWords(node: SNode, str: string) {
        if (node.isWord) {
            if (node.refList.length) {
                this.wordList = this.wordList.concat(node.refList);
            } else {
                this.wordList.push(str);
            }
        }
        let i = 0;
        const tempNode = node.nodes;
        for (; i < charMap.size; i++) {
            if (tempNode && tempNode[i]) {
                this.getWords(tempNode[i], str + tempNode[i].data);
            }
        }
        return this.wordList;
    }
}
